import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { FarmService } from "src/app/services/farm-service.service";
import { PhameeService } from "src/app/services/phamee.service";
import { environment } from "../../../environments/environment";
import { UtilService } from "src/app/services/utils.service";

import * as moment from "moment";
import * as L from "leaflet";
import * as CovJSON from 'covjson-reader';
import * as C from 'leaflet-coverage';
import { ThaiComService } from "src/app/services/thaicom.service";

declare var $: any;

@Component({
  selector: "smart-farm-dashboard",
  templateUrl: "./farm-dashboard.component.html",
  styleUrls: [
    "./farm-dashboard.component.css",
    "../platform-color/platform-color.css",
  ],
})
export class FarmDashboardComponent implements OnInit {
  template: any = sessionStorage.getItem("template");
  map: L.Map;
  polygon: any;
  marker: any;;

  numberOfSensor = [];
  numberOfLatLong = [];
  centerpoint = [];

  markerControl = [];
  markerSensor = [];
  markerCamera = [];
  dateNow: any;
  allPlotCoordinates = [];

  controlActiveIcon = new L.Icon({
    iconUrl: "assets/img/control_map_atv_marker.png",
    iconSize: [30, 40],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  controlInActiveIcon = new L.Icon({
    iconUrl: "assets/img/control_map_ina_marker.png",
    iconSize: [30, 40],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  sensorActiveIcon = new L.Icon({
    iconUrl: "assets/img/sensor_map_atv_marker.png",
    iconSize: [30, 40],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  sensorInActiveIcon = new L.Icon({
    iconUrl: "assets/img/sensor_map_ina_marker.png",
    iconSize: [30, 40],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  cameraIcon = new L.Icon({
    iconUrl: "assets/img/camera_map_marker.png",
    iconSize: [30, 40],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  themeColor = sessionStorage.getItem("colorObj")
    ? JSON.parse(sessionStorage.getItem("colorObj"))
    : {};

  weather: any;
  getPlot: any;
  AllPlot: any;
  farmDetail: any;
  isLoadPlant: boolean = false;
  expand: boolean = false;
  defaultChildOrg: string;
  systemRole: string;
  farmId: string;

  ChildOrgList: any = [];
  AllFarmList: any = [];
  FarmList: any = [];
  controlList: any = [];
  sensorList: any = [];
  cameraList: any = [];
  FarmCenter: any = {};
  Province: any;
  District: any;
  totalPlot: number;
  covJson: any = [];
  start_thai_com_datetime: any;
  end_thai_com_datetime: any;

  onclickSensor: boolean = false;
  onclickControl: boolean = false;
  onclickCamera: boolean = false;
  onclickPlant: boolean = false;
  confirmDeleteBtn: boolean = false;

  delete_id: string;
  delete_zone_id: string;
  plotName: string = "";
  cameraModal: string = "#cameraModal";
  deleteModal: string = "#deleteModal";
  successDelModal: string = "#successDelModal";
  warningModal: string = "#warningModal";

  os: string = "Windows";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private farmService: FarmService,
    private phameeService: PhameeService,
    private thaiComService: ThaiComService,
    private spinner: NgxSpinnerService,
    private UtilService: UtilService
  ) {
    this.totalPlot = this.UtilService.totalplot;
  }
  public async backToSelectOrganize() {
    this.spinner.show();
    setTimeout(async () => {
      sessionStorage.clear();
      this.spinner.hide();
      window.location.href = `${environment.GATEWAY_URL}/homepage`;
    }, 1000);
  }

  ngOnInit() {
    this.defaultChildOrg = this.route.snapshot.queryParams["childorg"];
    this.systemRole = sessionStorage.getItem("system_role");

    this.getdateNow();
    this.getDropdown();

    this.os = this.getMobileOperatingSystem();
  }

  getdateNow() {
    const eventNow = new Date();
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    } as const;
    this.dateNow = eventNow.toLocaleDateString("th-TH", options);
  }

  getPlots(farmId) {
    this.spinner.show();
    this.onclickSensor = false;
    this.onclickControl = false;
    this.markerControl = [];
    this.markerSensor = [];

    this.phameeService.getPlotDashboard(farmId).subscribe((success) => {

      if (success.code == 200) {
        this.AllPlot = success.data.plot;

        this.getPlot = success.data.plot[0];
        this.FarmCenter = this.getPlot.center;
        this.Province = this.getPlot.location.province.name_th;
        this.District = this.getPlot.location.district.name_th;

        sessionStorage.setItem("farmId", farmId);

        if (!sessionStorage.getItem("role").includes("admin")) {
          sessionStorage.setItem("role", success.data.role);
        }
        this.allPlotCoordinates = [];
        this.controlList = [];
        this.sensorList = [];

        for (let i = 0; i < this.AllPlot.length; i++) {
          const element = this.AllPlot[i];

          Object.assign(element, { widget_sensor: [] });
          this.allPlotCoordinates.push({
            plotId: element._id,
            coordinates: element.coordinates,
            zone: element.zone,
          });

          if (element.thing.length > 0) {
            for (let j = 0; j < element.thing.length; j++) {
              const elementThing = element.thing[j];
              if (elementThing.control.length > 0) {
                elementThing.control.forEach((control) => {
                  if (control.active) {
                    this.controlList.push({
                      coordinates: control.coordinates,
                      sensor_id: control.sensor_id,
                      sensor_desc: control.sensor_desc,
                      last_active_value: control.last_active_value
                        ? control.last_active_value
                        : null,
                    });
                  }
                });
              }
              if (elementThing.sensor.length > 0) {
                elementThing.sensor.forEach((sensor) => {
                  if (
                    sensor.active &&
                    !["camera", "video", "image_capture"].includes(sensor.type)
                  ) {
                    this.sensorList.push({
                      coordinates: sensor.coordinates,
                      sensor_id: sensor.sensor_id,
                      sensor_desc: sensor.sensor_desc,
                      lastValue: sensor.lastValue,
                      last_active_value: sensor.last_active_value,
                    });
                    element.widget_sensor.push(sensor);
                  }
                });
              }
            }
          }
        }
        this.covJson = [];
        this.getPlant();
        this.initMap();
        this.setPolygon();
        this.getWeather(this.FarmCenter);
        this.showSensor();
      } else {
        if (this.map) {
          this.map.remove();
        }
        this.map = null;
        this.AllPlot = [];
        this.covJson = [];
        this.controlList = [];
        this.sensorList = [];
      }

      this.spinner.hide();
    });
  }

  async getPlant() {
    this.isLoadPlant = false;
    this.spinner.show();
  
    try {
      const thaicomKeyResponse = await this.thaiComService.getThaicomKey();
      if (thaicomKeyResponse.code !== 200) return;
  
      const authResponse = await this.thaiComService.auth(thaicomKeyResponse.value);
      if (!authResponse.success) return;
  
      await Promise.all(
        this.AllPlot.map(plot => this.handlePlot(plot, authResponse.access_token, thaicomKeyResponse.value))
      );
    } finally {
      this.isLoadPlant = true;
      this.spinner.hide();
    }
  }
  
  private async handlePlot(plot, accessToken: string, thaicomKey: string) {
    if (!plot.crop.plantingType_id) return;
  
    const plantTypeRes = await this.thaiComService.getPlantTypeById(plot.crop.plantingType_id);
    const isOutdoor =
    plantTypeRes &&
    plantTypeRes.data &&
    plantTypeRes.data.some(plant => plant && plant.name === 'กลางแจ้ง');

    if (!isOutdoor) return;
  
    const coords = this.buildPolygonCoords(plot.coordinates.map_polygon);
  
    const startDatetime = moment().subtract(1, 'months').format("YYYY-MM-DDTHH:mm:ss");
    const endDatetime = moment().format("YYYY-MM-DDTHH:mm:ss");
  
    const params = new URLSearchParams({
      coords: `POLYGON ((${coords}))`,
      datetime: `${startDatetime}/${endDatetime}`,
      crs: '4326'
    }).toString();
  
    const areaRes = await this.thaiComService.getArea(params, accessToken, thaicomKey);
    areaRes.parameters.ndvi.observedProperty.label.en = plot.name;
  
    this.covJson.push(areaRes);
  }
  
  private buildPolygonCoords(polygons: any[]) {
    const coordList = polygons.map(p => `${p.lon} ${p.lat}`);
    // ปิด polygon ด้วยจุดแรก
    coordList.push(coordList[0]);
    return coordList.join(', ');
  }
  

  getFarmByName(farmId) {
    this.spinner.show();
    const farmName = this.FarmList.find((farm) => farm.value == farmId).name;
    if (farmName) {
      this.farmService.getFarmByName(farmName).subscribe((success) => {
        if (success.code == 200) {
          this.farmDetail = success.data[0];

          this.spinner.hide();
        }
      });
    }
  }

  getDropdown() {
    this.spinner.show();
    this.phameeService.getDropdownDashboard().subscribe(async (success) => {
      if (success.code == 200) {
        let data = success.data;

        sessionStorage.setItem("Org", data.dafaultOrg);
        sessionStorage.setItem("ChildOrg", data.defaultChildOrg);
        if (data.SystemRole) sessionStorage.setItem("role", "admin");
        data.ChildOrgList.forEach((element) => {
          this.ChildOrgList.push({
            name: element.name,
            value: element._id,
          });
        });
        data.FarmList.forEach((element) => {
          this.AllFarmList.push({
            name: element.name,
            value: element._id,
            child_org_id: element.child_org_id,
          });
        });
        this.farmId = sessionStorage.getItem("farmId");
        this.defaultChildOrg = data.defaultChildOrg;
        if (this.defaultChildOrg) {
          this.FarmList = this.AllFarmList.filter(
            (cv) => cv.child_org_id === this.defaultChildOrg
          );

          this.getPlots(this.farmId ? this.farmId : this.FarmList[0].value);
          this.getFarmByName(
            this.farmId ? this.farmId : this.FarmList[0].value
          );
        } else {
          this.FarmList = this.AllFarmList;
          this.getPlots(this.farmId ? this.farmId : this.FarmList[0].value);
          this.getFarmByName(
            this.farmId ? this.farmId : this.FarmList[0].value
          );
        }
      }
    });
  }

  selectFarm(data) {
    this.getPlots(data);
    this.getFarmByName(data);
  }

  initMap(): void {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
    this.map = L.map("map", { zoomControl: false }).setView([this.FarmCenter.center.lat, this.FarmCenter.center.lon], this.FarmCenter.center.zoom_lv);

    var map = this.map;
    L.control.zoom({ position: "topright" }).addTo(map);

    L.tileLayer(
      "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
      { maxNativeZoom: 17, maxZoom: 18, minZoom: 5 }
    ).addTo(map);
  }

  setPolygon() {
    this.cameraList = [];

    let beforeTarget;
    let beforeId;
    for (let i = 0; i < this.allPlotCoordinates.length; i++) {
      this.numberOfLatLong = [];
      for (
        let lt = 0;
        lt < this.allPlotCoordinates[i].coordinates.map_polygon.length;
        lt++
      ) {
        this.numberOfLatLong[lt] = [
          this.allPlotCoordinates[i].coordinates.map_polygon[lt].lat,
          this.allPlotCoordinates[i].coordinates.map_polygon[lt].lon,
        ];
      }
      let latLong = this.numberOfLatLong;
      let thisPlot = this.AllPlot.filter(
        (cv) => cv._id === this.allPlotCoordinates[i].plotId
      );
      this.polygon = L.polygon([[latLong]], {
        color: this.allPlotCoordinates[i].zone.color,
        fillColor: thisPlot[0].status == "on_crop" ? this.allPlotCoordinates[i].zone.color : "#ffffff",
        fillOpacity: 0.4,
      }).addTo(this.map);

      if (thisPlot[0].camera_flag) {
        this.cameraList.push(
          {
            coordinates: {
              lat: this.polygon.getBounds().getCenter().lat,
              lon: this.polygon.getBounds().getCenter().lng,
            },
          }
        )
      }

      this.polygon.on("click", (e) => {
        this.spinner.show();
        if (beforeTarget) {
          beforeTarget.setStyle({
            weight: 3,
          });
        }
        if (beforeId) {
          $(`#${beforeId}`).removeClass("card-highlight");
        }
        e.target.setStyle({
          weight: 9,
        });
        beforeTarget = e.target;
        beforeId = this.allPlotCoordinates[i].plotId;
        this.map.flyTo(
          [
            this.allPlotCoordinates[i].coordinates.center.lat,
            this.allPlotCoordinates[i].coordinates.center.lon,
          ],
          this.allPlotCoordinates[i].coordinates.center.zoom_lv
        );
        setTimeout(async () => {
          this.highlighCard(this.allPlotCoordinates[i].plotId);
          this.spinner.hide();
        }, 500);
      });
      this.polygon.on("mouseout", function (e) {
        if (beforeTarget) {
          beforeTarget.setStyle({
            weight: 3,
          });
          $(`#${beforeId}`).removeClass("card-highlight");
        }
      });
    }
  }

  highlighCard(plotId) {
    let selectedPlot = this.AllPlot.filter(
      (cv) => cv._id === plotId
    );
    let otherPlot = this.AllPlot.filter(
      (cv) => cv._id !== plotId
    );
    otherPlot.unshift(selectedPlot[0]);
    this.getPlot = selectedPlot[0];
    this.AllPlot = otherPlot;
    $(`#${plotId}`).addClass("card-highlight");
  }

  filterCovJson(cov) {
    let t = cov.ranges.ndvi.shape[0];
    let y = cov.ranges.ndvi.shape[1];
    let x = cov.ranges.ndvi.shape[2];
    let values = cov.ranges.ndvi.values;
    let countJson = cov.ranges.ndvi.values.length;
    let countPerTime = y * x;

    if (countJson > countPerTime) {
      let start = countJson - countPerTime;
      let stop = countJson;
      for (let index = 0; index < t; index++) {

        let filterValues = values.filter((number, v) => v >= start && v <= stop);

        if (filterValues.find(number => number)) {
          cov.ranges.ndvi.values = filterValues;
          break;
        } else {
          stop = start - 1;
          start = stop - countPerTime + 1;
        }
      }
    }
    return cov
  }

  showPlant(name: string) {
    var map = this.map;

    this.covJson.sort(function (a, b) {
      if (a.parameters.ndvi.observedProperty.label.en < b.parameters.ndvi.observedProperty.label.en) { return -1; }
      if (a.parameters.ndvi.observedProperty.label.en > b.parameters.ndvi.observedProperty.label.en) { return 1; }
      return 0;
    })
    let covJson = this.covJson;

    this.active("plant");

    this.clearLayers();

    var layers = [];
    if (name) {
      covJson.map((cov, index) => {

        if (name == cov.parameters.ndvi.observedProperty.label.en) {
          cov = this.filterCovJson(cov);
          CovJSON.read(cov).then(function (coverage) {

            var layer = C.dataLayer(coverage, { parameter: 'ndvi', palette: C.linearPalette(['#FF0000', '#FF7F50', '#FFFF00', '#00FF00', '#006A4E']), })
              .on('afterAdd', function () {
                let [low, high] = layer.paletteExtent;

                if (!isNaN(low) && !isNaN(high)) {
                  C.legend(layer).addTo(map);
                }
              })
              .addTo(map);

            layers.push(layer);
          })
        }
      })
    } else {
      this.plotName = "";
      covJson.map((cov, index) => {
        cov = this.filterCovJson(cov);
        CovJSON.read(cov).then(function (coverage) {

          var layer = C.dataLayer(coverage, { parameter: 'ndvi', palette: C.linearPalette(['#FF0000', '#FF7F50', '#FFFF00', '#00FF00', '#006A4E']), })
            .on('afterAdd', function () {
            })
            .addTo(map);

          layers.push(layer);
        })
      })
    }

    map.on('click', function (e) {
      new C.DraggableValuePopup({
        layers: layers
      }).setLatLng(e['latlng']).openOn(map);
    })
  }

  showControl() {
    if (this.onclickPlant) {
      this.initMap();
      this.setPolygon();
    }
    if (this.markerControl.length == 0) {

      if (this.controlList.length > 0) {
        this.active("control");
        for (let i = 0; i < this.controlList.length; i++) {
          this.numberOfSensor[i] = [
            this.controlList[i].coordinates.map_point.lat || "",
            this.controlList[i].coordinates.map_point.lon || "",
          ];
          if (this.controlList[i].last_active_value == "1")
            this.marker = L.marker(this.numberOfSensor[i], {
              icon: this.controlActiveIcon,
            }).addTo(this.map);
          else
            this.marker = L.marker(this.numberOfSensor[i], {
              icon: this.controlInActiveIcon,
            }).addTo(this.map);
          const customOptions = {
            className: "custom-popup",
            closeButton: false,
          };
          this.marker.bindPopup(
            `${this.controlList[i].sensor_id}`,
            customOptions
          );
          this.marker.on("click", (e) => { });
          this.markerControl.push(this.marker);
        }
      } else {
        this.onclickControl = false;
      }
      this.clearMarkSensor();
      this.clearMarkCamera();
    } else if (this.markerControl.length != 0) {
      this.onclickControl = false;
      this.clearMarkControl();
    }
  }

  showSensor() {
    if (this.onclickPlant) {
      this.initMap();
      this.setPolygon();
    }
    if (this.markerSensor.length == 0) {
      if (this.sensorList.length > 0) {
        this.active("sensor");
        for (let i = 0; i < this.sensorList.length; i++) {
          this.numberOfSensor[i] = [
            this.sensorList[i].coordinates.map_point.lat || "",
            this.sensorList[i].coordinates.map_point.lon || "",
          ];
          if (
            this.sensorList[i].lastValue == null ||
            this.sensorList[i].lastValue == "null"
          )
            this.marker = L.marker(this.numberOfSensor[i], {
              icon: this.sensorInActiveIcon,
            }).addTo(this.map);
          else
            this.marker = L.marker(this.numberOfSensor[i], {
              icon: this.sensorActiveIcon,
            }).addTo(this.map);
          const customOptions = {
            className: "custom-popup",
            closeButton: false,
          };
          this.marker.bindPopup(
            `${this.sensorList[i].sensor_id} ${this.sensorList[i].last_active_value}`,
            customOptions
          );
          this.marker.on("click", (e) => { });
          this.markerSensor.push(this.marker);
        }

        this.clearMarkControl();
        this.clearMarkCamera();
      } else {
        this.onclickSensor = false;
      }
    } else if (this.markerSensor.length != 0) {
      this.onclickSensor = false;
      this.clearMarkSensor();
    }
  }

  showCamera() {
    if (this.onclickPlant) {
      this.initMap();
      this.setPolygon();
    }
    if (this.markerCamera.length == 0) {

      if (this.cameraList.length > 0) {
        this.active("camera");

        for (let i = 0; i < this.cameraList.length; i++) {
          this.numberOfSensor[i] = [
            this.cameraList[i].coordinates.lat || "",
            this.cameraList[i].coordinates.lon || "",
          ];

          this.marker = L.marker(this.numberOfSensor[i], {
            icon: this.cameraIcon,
          }).addTo(this.map);

          this.marker.on("click", (e) => {
            if (this.os == "Android" || this.os == "IOS") {
              $(`${this.cameraModal}`).modal("show");
            }
          });
          this.markerCamera.push(this.marker);
        }

        this.clearMarkSensor();
        this.clearMarkControl();
      } else {
        this.onclickCamera = false;
      }
    } else if (this.markerCamera.length != 0) {
      this.onclickCamera = false;
      this.clearMarkCamera();
    }

  }

  active(name: string) {
    if (name == 'plant') {
      this.onclickPlant = true;
      this.onclickControl = false;
      this.onclickSensor = false;
      this.onclickCamera = false;
    } else if (name == 'sensor') {
      this.onclickPlant = false;
      this.onclickControl = false;
      this.onclickSensor = true;
      this.onclickCamera = false;
    } else if (name == 'control') {
      this.onclickPlant = false;
      this.onclickControl = true;
      this.onclickSensor = false;
      this.onclickCamera = false;
    } else {
      this.onclickPlant = false;
      this.onclickControl = false;
      this.onclickSensor = false;
      this.onclickCamera = true;
    }
  }

  goCamera() {
    $(`${this.cameraModal}`).modal("hide");

    if (this.os == "IOS") {
      window.open("https://ais-myliving.com/aissmartcam/", '_blank');
    } else {
      var customURL = "aisiot://th.co.mimotech.android.aismyliving";

      var openedWindow = window.open(customURL, '_blank');

      if (openedWindow && openedWindow.location.href === 'about:blank') {
        openedWindow.close();
        window.open("https://ais-myliving.com/aissmartcam/", '_blank');
      }
    }
  }

  getMobileOperatingSystem() {
    if (navigator.userAgent.match(/Android/i)) {
      return "Android";
    } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      return "IOS";
    } else {
      return "Windows";
    }
  }

  clearMarkControl() {
    if (this.markerControl.length != 0) {
      for (var mi = 0; mi < this.markerControl.length; mi++) {
        this.map.removeLayer(this.markerControl[mi]);
      }
      this.markerControl.length = 0;
    }

    this.clearPlantLayers();
  }

  clearMarkSensor() {
    if (this.markerSensor.length != 0) {
      for (var mi = 0; mi < this.markerSensor.length; mi++) {
        this.map.removeLayer(this.markerSensor[mi]);
      }
      this.markerSensor.length = 0;
    }

    this.clearPlantLayers();
  }

  clearMarkCamera() {
    if (this.markerCamera.length != 0) {
      for (var mi = 0; mi < this.markerCamera.length; mi++) {
        this.map.removeLayer(this.markerCamera[mi]);
      }
      this.markerCamera.length = 0;
    }

    this.clearPlantLayers();
  }

  clearLayers() {
    this.map.eachLayer((layer) => {

      let options = layer['options'];
      if (options.minZoom && options.maxZoom) {
      } else {
        this.map.removeLayer(layer);
      }
    })
  }

  clearPlantLayers() {
    this.map.eachLayer((layer) => {

      let options = layer['options'];
      if (options.parameter == 'NDVI') {
        this.map.removeLayer(layer);
      }
    })
  }

  async getWeather(latlon) {
    let filter = {
      latitude: latlon.center.lat,
      longitude: latlon.center.lon,
    };
    this.spinner.show();
    this.farmService.getWeather(filter).subscribe(async (success) => {
      if (success.code == "200") {
        this.weather = success.data;
        this.farmService.getWeathers(filter).subscribe(async (success) => {
          if (success.code == "200") {
            let forecasts = [];
            let currentDay = moment(new Date()).format("YYYY-MM-DD");
            for (var i = 1; i <= 5; i++) {

              currentDay = moment(currentDay).add(1, 'days').format("YYYY-MM-DD");
              let obj = success.data.list.find(
                (item) =>
                  moment(item.dt_txt).format("YYYY-MM-DD") == currentDay
              );
              if (obj) {
                obj.date = this.weatherDay(obj.dt);
                forecasts.push(obj);
              }
            }
            this.weather.forecasts = forecasts;
          }

          this.spinner.hide();
        });
      }

      this.spinner.hide();
    });
  }

  expandWeather() {
    if (this.expand == true) {
      $("#plot-sm-id-down").addClass("sw-mb");
      $("#plot-sm-id-down").removeClass("hd-mb");
      $("#plot-sm-id-up").addClass("hd-mb");
    } else {
      $("#plot-sm-id-down").addClass("hd-mb");
      $("#plot-sm-id-up").removeClass("hd-mb");
      $("#plot-sm-id-up").addClass("sw-mb");
    }
    this.expand = !this.expand;
  }

  weatherDay(date) {
    date = moment.unix(date);
    const dow = date.day();
    date = new Date(date);
    let newDate = date.getDate();
    let result;
    if (dow !== undefined) {
      switch (dow) {
        case 0:
          result = "อา. " + newDate;
          break;
        case 1:
          result = "จ. " + newDate;
          break;
        case 2:
          result = "อ. " + newDate;
          break;
        case 3:
          result = "พ. " + newDate;
          break;
        case 4:
          result = "พฤ. " + newDate;
          break;
        case 5:
          result = "ศ. " + newDate;
          break;
        case 6:
          result = "ส. " + newDate;
          break;
      }
    }
    return result;
  }

  delete(plot) {
    this.delete_id = plot.id;
    this.delete_zone_id = plot.zone_id;
    $(`${this.deleteModal}`).modal("show");
  }

  addPlot() {
    if (this.AllPlot.length >= this.totalPlot) {
      $(`${this.warningModal}`).modal("show");
    } else {
      this.router.navigate([
        `/manage-farm/${this.farmDetail._id}/${this.farmDetail.name}/plot/createPlot`,
      ]);
    }
  }

  delPlot() {
    this.farmService.deletePlot(this.delete_id).subscribe(async (res) => {
      this.farmService
        .deleteZone(this.delete_zone_id)
        .subscribe(async (zone) => {
          $(`${this.deleteModal}`).modal("hide");

          await this.phameeService
            .getPlotMenu(sessionStorage.getItem("ChildOrg"))
            .subscribe((response) => {
              let arrMenu = [];
              if (response.code == 200) {
                arrMenu = response.data;
                sessionStorage.setItem("menufarm", JSON.stringify(arrMenu));

                window.location.reload();
              }
            });
        });
    });
  }

  openGoogleMap() {
    let url =
      "https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" +
      this.farmDetail.coordinates.center.lat +
      "," +
      this.farmDetail.coordinates.center.lon;
    window.open(url, "_blank");
  }

  back(): void {
    this.router.navigateByUrl("/manage-farm");
  }
}
